export default {
  FLAG_TOGGLE_REQUESTED: 'FLAG_TOGGLE_REQUESTED',
  FLAG_TOGGLE_SUCCEEDED: 'FLAG_TOGGLE_SUCCEEDED',
  FLAG_TOGGLE_FAILED: 'FLAG_TOGGLE_FAILED',
  FLAG_TOGGLED: 'FLAG_TOGGLED',
};
